import { call, put } from 'redux-saga/effects'
import req from '@sportninja/common/api/request'
import actions from '../actions/registration'
import { generateSagas } from './utils'

const api = {
  getDivisions: async (scheduleId) => {
    const response = await req(`/registration/${scheduleId}/admin/detailed`)
    const analytics = await req(`/registration/${scheduleId}/admin/analytics`)
    return { response: response.data, analytics: analytics.data }
  },
  createRegistration: async ({ level, scheduleId, info }) => {
    const url =
      level === 'schedule'
        ? `/registration/${scheduleId}/admin`
        : `/registration/${scheduleId}/admin/division`
    const response = await req(url, {
      method: 'POST',
      body: JSON.stringify(info),
    })
    return response.data
  },
  getSettings: async ({ level, scheduleId }) => {
    const url =
      level === 'schedule'
        ? `/registration/${scheduleId}/admin`
        : `/registration/${scheduleId}/admin/division`
    const response = await req(url)
    return response.data
  },
  updateRegistration: async ({ level, scheduleId, info }) => {
    const url =
      level === 'schedule'
        ? `/registration/${scheduleId}/admin`
        : `/registration/${scheduleId}/admin/division`
    const response = await req(url, {
      method: 'PUT',
      body: JSON.stringify(info),
    })
    return response.data
  },
  updateTeamRegStatus: async ({
    scheduleId,
    teamId,
    scheduleRegistrationId,
    status,
    conditions,
    conditionType,
    divisionId,
    teamRosterId,
  }) => {
    const body = {
      schedule_registration_id: scheduleRegistrationId,
      team_id: teamId,
      conditions,
      condition_type_id: conditionType,
      status,
      team_roster_id: teamRosterId,
    }
    if (divisionId) {
      body.division_id = divisionId
    }
    const response = await req(`/registration/${scheduleId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
    return response.data
  },
  checkPayments: async () => {
    const deposits = await req('/users/me/deposits/pending')
    const installments = await req('/users/me/installments/pending')
    return { deposits: deposits.data, installments: installments?.data }
  },
}

const registrationSagas = [
  [
    actions.loadDivisions,
    function* ({ scheduleId }) {
      const result = yield call(api.getDivisions, scheduleId)
      yield put(
        actions.loadDivisions.success({
          response: result.response,
          analytics: result.analytics,
        })
      )
      return result
    },
  ],
  [
    actions.createRegistration,
    function* ({ level = 'schedule', scheduleId, info }) {
      yield call(api.createRegistration, { level, scheduleId, info })
      // Re-load divisions after creation
      const result = yield call(
        api.getDivisions,
        scheduleId
      )
      yield put(actions.createRegistration.success())
      yield put(
        actions.loadDivisions.success({
          response: result.response,
          analytics: result.analytics,
        })
      )
      return result
    },
  ],
  [
    actions.getSettings,
    function* ({ level = 'schedule', scheduleId }) {
      const data = yield call(api.getSettings, { level, scheduleId })
      yield put(actions.getSettings.success({ data }))
      return data
    },
  ],
  [
    actions.updateRegistration,
    function* ({ level = 'schedule', scheduleId, info }) {
      const data = yield call(api.updateRegistration, { level, scheduleId, info })
      yield put(actions.updateRegistration.success({ data }))
      // Re-load divisions
      const result = yield call(api.getDivisions, scheduleId)
      yield put(
        actions.loadDivisions.success({
          response: result.response,
          analytics: result.analytics,
        })
      )
      return data
    },
  ],
  [
    actions.updateDivision,
    function* ({ scheduleId, info }) {
      yield call(api.updateRegistration, {
        level: 'division',
        scheduleId,
        info,
      })
      yield put(actions.updateDivision.success())
      return
    },
  ],
  [
    actions.updateTeamRegStatus,
    function* (payload) {
      yield call(api.updateTeamRegStatus, payload)
      yield put(actions.updateTeamRegStatus.success())
      // Re-load divisions after status change
      const result = yield call(api.getDivisions, payload.scheduleId)
      yield put(
        actions.loadDivisions.success({
          response: result.response,
          analytics: result.analytics,
        })
      )
      return
    },
  ],
  [
    actions.checkPayments,
    function* () {
      const result = yield call(api.checkPayments)
      yield put(actions.checkPayments.success(result))
      return result
    },
  ],
]

export default generateSagas([...registrationSagas])
